import {
  CrmFieldService,
  StandardIds,
  SystemFieldIds,
} from '@galaxy/crm/services/field-service';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  WritableSignal,
  signal,
  Signal,
  computed,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from '../../../i18n/translation-module';
import { CollapsibleSectionComponent } from '../../collapsible-section/collapsible-section.component';
import { ActivityInterface } from '@vendasta/crm';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { ActivityRichTextComponent } from './activity-rich-text.component';

@Component({
  selector: 'crm-activity-logged-communication',
  templateUrl: './logged-communication.component.html',
  styleUrls: ['./logged-communication.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    TranslateModule,
    TranslationModule,
    CollapsibleSectionComponent,
    GalaxyPipesModule,
    ActivityRichTextComponent,
  ],
})
export class CrmActivityLoggedCommunicationComponent {
  private _activity: WritableSignal<ActivityInterface> = signal({});
  @Input({ required: true }) set activity(activity: ActivityInterface) {
    this._activity.set(activity);
  }

  get activity() {
    return this._activity();
  }

  dateFormat = DateFormat.mediumDateShortTime;

  cardInfo: Signal<ActivityCardInformation> = computed(() => {
    const cardInfo: any = {
      body: this.getFieldData(this._activity(), StandardIds.ActivityCommunicationBody),
      summaryTitle: this.getFieldData(this._activity(), StandardIds.ActivityCommunicationSummaryTitle),
      summaryBody: this.getFieldData(this._activity(), StandardIds.ActivityCommunicationSummaryBody),
      activityUrl: this.getFieldData(this._activity(), StandardIds.ActivityUrl),
      activityUrlName: this.getFieldData(this._activity(), StandardIds.ActivityUrlName) ?? '',
      channel: this.getFieldData(this._activity(), StandardIds.ActivityCommunicationChannel),
      outcome: this.getFieldData(this._activity(), StandardIds.ActivityCommunicationOutcome),
      date:
        this.fieldService.getFieldValueFromCrmObject(this._activity(), SystemFieldIds.ActivityEffectiveDate)
          ?.dateValue ?? null,
    };
    return cardInfo;
  });

  private getFieldData(activity: ActivityInterface, fieldId: string): string {
    return this.fieldService.getFieldValueFromCrmObject(activity, fieldId)?.stringValue ?? '';
  }

  constructor(private readonly fieldService: CrmFieldService) {}
}

interface ActivityCardInformation {
  body: string;
  summaryTitle: string;
  summaryBody: string;
  activityUrl: string | null;
  activityUrlName: string;
  channel: string;
  outcome: string;
  date: Date;
}
